import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';

import { IUModalConfig } from '../../contexts/ModalContext';

const GlobalModal = ({ config, onHide }: { config: IUModalConfig, onHide: () => void }) => {
  const hideClick = () => {
    if (config.onHide) {
      config.onHide();
    } else {
      onHide();
    }
  };

  const onSubmit = () => {
    config.onSubmit ? config.onSubmit() : onHide();
  };

  let header;
  if (config.isError) {
    header = <MyErrorHeader closeButton={true}>
      <Modal.Title>
        {config.title ?? 'Error'}
      </Modal.Title>
    </MyErrorHeader>;
  } else {
    header = <Modal.Header closeButton={true}>
      <Modal.Title>
        {config.title}
      </Modal.Title>
    </Modal.Header>;
  }

  const showCancel = (config.showCancel !== false) && !config.isError;

  return <Modal centered size="lg" show={true} onHide={hideClick} data-testid="global-modal">
    {header}
    <Modal.Body>
      {config.contents}
    </Modal.Body>
    <Modal.Footer>
      {showCancel ?
        <MyButton variant="secondary" onClick={hideClick}>{config.cancelText || 'Cancel'}</MyButton> : null}
      <MyButton onClick={onSubmit}>{config.submitText || 'OK'}</MyButton>
    </Modal.Footer>
  </Modal>;
};
const MyButton = styled(Button)`
  margin: 0 10px;
`;
const MyErrorHeader = styled(Modal.Header)`
  background-color: #e85e6c;
  color: #ffffff;
`;

export default GlobalModal;
